import {Button, Divider, Grid, TextField, Typography} from "@mui/material";
import React from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Company} from "../../../../types/company";
import {AuctionState, AuctionType} from "../../../../utils/enums";
import LotCard from "./components/LotCard";
import {AuctionLot} from "../../../../types/auction";

export type LotFieldsProps = {
    company: Company | null,
    lots: AuctionLot[],
    auctionType: AuctionType,
    auctionState: AuctionState,
    auctionId: number,
}
export const LotFields = ({
                              company,
                              lots,
                              auctionType,
                              auctionState,
                              auctionId
                          }: LotFieldsProps) => {
    const {t} = useTranslation();

    const navigate = useNavigate();
    const [isNewOpen, setIsNewOpen] = React.useState(false);
    const onOpenLot = () => setIsNewOpen(true);

    return <Grid container>
            {!!lots && lots.length > 0 &&
                <Grid container spacing={3}>
                    {lots.map(lot => (
                        <Grid item xs={12} key={lot.id}>
                            <LotCard
                                id={lot.id}
                                lot={lot.lotDto}
                                maxItems={5}
                                company={company!}
                                auctionId={auctionId}
                            />

                            <Divider sx={{mt: 3, ml: "auto", width: '98%'}}/>

                            <Grid container columnSpacing={3} rowSpacing={1} sx={{mt: 1}}>
                                <Grid item xs={12} sx={{mb: 1}}>
                                    <Typography variant="h6">
                                        {t("auction.sections.terms")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={8} md={8}>
                                    <TextField
                                        fullWidth color="primary" type="text" size="small"
                                        label={t("auction.dictionary.deliveryCondition")}
                                        value={lot.lotDto?.deliveryType?.label}
                                        InputProps={{readOnly: true}}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={4}>
                                    <TextField
                                        fullWidth color="primary" type="text" size="small"
                                        label={t("auction.fields.deliveryTime")}
                                        value={new Date(lot.lotDto!.deliveryDate!).toLocaleDateString()}
                                        InputProps={{readOnly: true}}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            }


    </Grid>
}